import React from 'react'
import { graphql } from 'gatsby'
import { Content } from 'partials/ArchLogProductListPage/index'

/**
 *
 */
const ArchLogProductsTemplate = ({ pageContext }) => {
  return (
    <div>
      <Content data={pageContext.data} />
    </div>
  )
}

export const query = graphql`
  query ArchLogProductQuery {
    allWordpressPost(
      filter: { categories: { elemMatch: { slug: { eq: "products" } } } }
    ) {
      nodes {
        id
        wordpress_id
        slug
        title
      }
    }
  }
`

/**
 *
 */
export default ArchLogProductsTemplate
